import React, { useState } from "react";
import cx from "classnames";
import { useDeviceType } from "components/Layout/useDeviceType";
import s from "./LeftSidebar.module.scss";
import { SidebarToggle } from "./SidebarToggle";

type SideBarWrapperProps = {
  children: React.ReactElement;
  width: number;
  isOpenDefault?: boolean;
  withToggle: boolean;
  toggleText: string;
  isFirstSidebar?: boolean;
  zIndex?: number;
  toggleOnLeft?: boolean;
  color?: string;
  isRightSidebarToggle: boolean;
  classNames: string;
};

export const SideBarWrapper = ({
  children,
  width,
  isOpenDefault = true,
  withToggle = false,
  toggleText,
  isFirstSidebar = false,
  zIndex = 0,
  toggleOnLeft = false,
  color = "primary",
  isRightSidebarToggle,
  classNames,
}: SideBarWrapperProps) => {
  const deviceType = useDeviceType();
  const [show, setShow] = useState(deviceType === "desktop" && isOpenDefault);
  const [lastDeviceType, setLastDeviceType] = useState(deviceType);

  if (lastDeviceType !== deviceType) {
    setLastDeviceType(deviceType);
    setShow(deviceType === "desktop" && isOpenDefault);
  }

  return (
    <div
      className={cx("h-full-exclude-footer", s.sideBarWrapper, s[classNames], {
        [s.sideBarWrapperTablet]: isRightSidebarToggle,
      })}
      style={{
        width: show ? width : 0,
        zIndex,
      }}
    >
      <div
        className={cx(
          "h-full-exclude-footer position-fixed page-start-top",
          s.sideBarWrapper,
          s[classNames],
        )}
        style={{ width: show ? width : 0 }}
      >
        <div className={cx("h-100", s.customScrollBar)}>{children}</div>
        {withToggle && (
          <SidebarToggle
            setIsOpened={setShow}
            isOpened={show}
            isFirstSidebar={isFirstSidebar}
            text={toggleText}
            onLeft={toggleOnLeft}
            color={color}
            isRightSidebarToggle={isRightSidebarToggle}
          />
        )}
      </div>
    </div>
  );
};
